export default function kitcut(text: string, limit: number): string {
  text = text.trim()

  return text.length > limit ? `${text.slice(0, limit)}...` : text
}
